module.exports = __webpack_public_path__ + "static/media/icon_modify_w.72936470.svg";